import { createSelector } from 'reselect'

const integrationsSelector = (state) => (state.integrations)

const paypalSelector = createSelector(
  integrationsSelector,
  (integrations) => integrations.paypal_ppcp
)

const accountSelector = createSelector(
  paypalSelector,
  (paypalPpcp) => paypalPpcp.account
)

export const accountIsLoadingSelector = createSelector(
  accountSelector,
  (account) => account.isLoading
)

export const paypalConnectedSelector = createSelector(
  accountSelector,
  (account) => account.connected
)

export const connectionDisallowedSelector = createSelector(
  accountSelector,
  (account) => account.connectionDisallowed
)

export const emailConfirmedSelector = createSelector(
  accountSelector,
  (account) => account.emailConfirmed
)

export const emailSelector = createSelector(
  accountSelector,
  (account) => account.email
)
